import gql from 'graphql-tag'

export default gql`
fragment CashBookSettingsMain on CashBookSettings {
	description
	active
	shouldAccount
	haveAccount
	tax
	taxAmount
	type
}
`
